import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=df9b1404&scoped=true&"
import script from "./addressEdit.vue?vue&type=script&lang=js&"
export * from "./addressEdit.vue?vue&type=script&lang=js&"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=df9b1404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b1404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9b1404')) {
      api.createRecord('df9b1404', component.options)
    } else {
      api.reload('df9b1404', component.options)
    }
    module.hot.accept("./addressEdit.vue?vue&type=template&id=df9b1404&scoped=true&", function () {
      api.rerender('df9b1404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/person/addressEdit.vue"
export default component.exports